module.exports = require("@splunk/themes/getSettingsFromThemedProps");